import React, { useContext } from 'react'
import { useNavigate, Navigate } from 'react-router-dom'
import UserContext from './contexts/userContext';

/** Function to restrict manager and reception users to access contractor dashboard and
**  allow only contractors to access the page
**/

function ContractorRoute({children}) {
    const navigate = useNavigate();

    const { user } = useContext(UserContext);

    return (
        user.userType == 'contractor' ? children : <Navigate to='/dashboard' replace />
    )
    
}

export default ContractorRoute;